import { 
  Avatar, 
  Button, 
  Flex, 
  Link, 
  Text, 
  useToast,
  Collapse,
  IconButton,
  Box
} from "@chakra-ui/react";
import React, { useState } from "react";
import { ChevronUpIcon, ChevronDownIcon } from "@chakra-ui/icons";
import AvatarImage from "assets/img/newGlogo.png";

export function SidebarHelp(props) {
  const { children, ...rest } = props;
  const toast = useToast();
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <Box
      position="relative"
      w="100%"
      mt="auto"
      pt="10px"
      pb="10px"
    >
      {!isExpanded && (
        <Button
          onClick={() => setIsExpanded(true)}
          w="90%"
          mx="5%"
          h="45px"
          bgGradient="linear-gradient(15.46deg, #298BE2 26.3%, #1069B8 86.4%)"
          color="white"
          _hover={{
            bgGradient: "linear-gradient(15.46deg, #3495EC 26.3%, #1573C2 86.4%)"
          }}
          _active={{
            transform: "scale(0.98)"
          }}
          fontSize="sm"
          fontWeight="bold"
          borderRadius="15px"
          rightIcon={<ChevronUpIcon />}
        >
          🎧 AR Guided Tours
        </Button>
      )}

      <Collapse in={isExpanded} animateOpacity>
        <Flex
          borderRadius="15px"
          flexDirection="column"
          bgGradient="linear-gradient(15.46deg, #298BE2 26.3%, #1069B8 86.4%)"
          justifyContent="center"
          alignItems="center"
          boxSize="border-box"
          p="16px"
          minH="220px"
          w="98%"
          mx="1%"
          position="relative"
        >
          <IconButton
            icon={<ChevronDownIcon />}
            size="sm"
            position="absolute"
            top="8px"
            right="8px"
            onClick={() => setIsExpanded(false)}
            bg="transparent"
            color="white"
            _hover={{
              bg: "whiteAlpha.200"
            }}
            aria-label="Collapse"
          />

          <Box fontSize="40px" mb="10px">
            🎧
          </Box>
          <Text fontSize="sm" color="white" fontWeight="bold">
            AR Guided Tours
          </Text>
          <Text textAlign="center" fontSize="xs" color="white" mb="10px" mt="10px">
            Audio-guided walking paths with AR navigation. Never get lost at holy sites or attractions.
          </Text>
          <Box 
            bg="whiteAlpha.200" 
            px={3} 
            py={1} 
            borderRadius="full"
            mb={3}
          >
            <Text fontSize="xs" color="white" fontWeight="600">
              ✨ Coming Soon
            </Text>
          </Box>
          <Link w="100%">
            <Flex justifyContent="center">
              <Button
                fontSize="10px"
                fontWeight="bold"
                w="80%"
                bg="#459ff0"
                _hover={{
                  bg: "#3487dc"
                }}
                _active={{
                  bg: "#064e8e",
                  transform: "none",
                  borderColor: "transparent",
                }}
                _focus={{
                  boxShadow: "none",
                }}
                color="white"
                onClick={() =>
                  toast({
                    title: `You'll be notified when this launches!`,
                    position: 'top',
                    isClosable: true,
                  })
                }
              >
                Join the Waitlist
              </Button>
            </Flex>
          </Link>
        </Flex>
      </Collapse>
    </Box>
  );
}